import { ChipProps as MuiChipProps } from '@mui/material';

import { StyledLinkChip } from './LinkChip.styled';

export type LinkChipProps = MuiChipProps & { href?: string };

export const LinkChip = ({ size = 'small', ...rest }: LinkChipProps) => (
  <StyledLinkChip clickable component="a" size={size} {...rest} />
);
